module.exports = __webpack_public_path__ + "static/img/product3-2.7cdd5dc1.png";